"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.constants = exports.aadErrorCode = exports.permissionsKeys = exports.descriptionMessageKeys = exports.logMessageKeys = void 0;
exports.logMessageKeys = {
    startExecuteDriver: "driver.aadApp.log.startExecuteDriver",
    successExecuteDriver: "driver.aadApp.log.successExecuteDriver",
    failExecuteDriver: "driver.aadApp.log.failExecuteDriver",
    startCreateAadApp: "driver.aadApp.log.startCreateAadApp",
    successCreateAadApp: "driver.aadApp.log.successCreateAadApp",
    skipCreateAadApp: "driver.aadApp.log.skipCreateAadApp",
    startGenerateClientSecret: "driver.aadApp.log.startGenerateClientSecret",
    successGenerateClientSecret: "driver.aadApp.log.successGenerateClientSecret",
    skipGenerateClientSecret: "driver.aadApp.log.skipGenerateClientSecret",
    outputAadAppManifest: "driver.aadApp.log.outputAadAppManifest",
    successUpdateAadAppManifest: "driver.aadApp.log.successUpdateAadAppManifest",
};
exports.descriptionMessageKeys = {
    create: "driver.aadApp.description.create",
    update: "driver.aadApp.description.update",
};
exports.permissionsKeys = {
    name: "Microsoft Entra App",
    owner: "Owner",
    noPermission: "No Permission",
    type: "M365",
};
exports.aadErrorCode = {
    permissionErrorCode: "CannotDeleteOrUpdateEnabledEntitlement",
};
exports.constants = {
    aadAppPasswordDisplayName: "default",
    oauthAuthorityPrefix: "https://login.microsoftonline.com",
};
//# sourceMappingURL=constants.js.map